import * as React from 'react'

function IconArrowNext(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={62}
      height={62}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x={62}
        y={62}
        width={62}
        height={62}
        rx={31}
        transform="rotate(-180 62 62)"
        fill="#E84E25"
      />
      <path
        d="M18.45 19.296v4.608l19.727 8.208-19.728 8.16v4.608l25.104-10.656v-4.272L18.45 19.296z"
        fill="#fff"
      />
    </svg>
  )
}

export default IconArrowNext
